var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgAct = function SvgAct(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    fill: "none",
    viewBox: "0 0 88 88"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "#105880",
    fillRule: "evenodd",
    d: "M33 16.5a19.25 19.25 0 0 0-19.25 19.25v3.14c0 9.01 6.2 16.58 14.56 18.68a2.75 2.75 0 0 1 2.08 2.67v13.2l15.69-14.56a2.75 2.75 0 0 1 1.87-.74H55A19.25 19.25 0 0 0 74.25 38.9v-3.14A19.25 19.25 0 0 0 55 16.5H33ZM8.25 35.75A24.75 24.75 0 0 1 33 11h22a24.75 24.75 0 0 1 24.75 24.75v3.14A24.75 24.75 0 0 1 55 63.64h-5.97L29.5 81.77a2.75 2.75 0 0 1-4.62-2.02V62.28A24.76 24.76 0 0 1 8.25 38.9v-3.14Z",
    clipRule: "evenodd"
  })));
};
export default SvgAct;